export class LoginEntidade {
  public Cpf?: string;
  public Senha?: string;
  public Inscricao?: string;
  public DataNascimento?: string;
  public Chave?: string;
  public SenhaAntiga?: string;
  public ConfirmarSenha?: string;
  public SenhaNova?: string;
  public Origem: number;
}
